var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isMobile)?_c('div',{staticClass:"mobile-tip"},[_c('img',{attrs:{"src":require("./assets/images/logo-small.png")}}),_c('h6',[_vm._v("十方实验室")]),_c('p',[_vm._v("请在电脑端打开查看")])]):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }